import { createContext, useContext } from 'react';
import type { AssignedAgency } from '../auth/agencyAccess';

export interface AgencyCampaignContextValue {
  agency: AssignedAgency;
}
export const AgencyCampaignContext = createContext<AgencyCampaignContextValue | null>(null);
export const useAgencyCampaignContext = () => useContext(AgencyCampaignContext);
